import { getWriterSuggestions, searchWritersSuggestions } from '@App/api/routes/search'
import { AutoCompleteFetchRequest } from '@App/stores/search/models/select-option-hide'

const getWriterNameAutoCompleteSuggestions = async ({
    searchTerm,
    rightsholderId,
    signal,
}: AutoCompleteFetchRequest) => {
    const normalizedProperty = 'fullName'
    let suggestions
    if (rightsholderId) {
        suggestions = await getWriterSuggestions(rightsholderId, normalizedProperty, searchTerm, signal)
    } else {
        suggestions = await searchWritersSuggestions(normalizedProperty, searchTerm, signal)
    }
    return suggestions.data || []
}

export default getWriterNameAutoCompleteSuggestions
